import { useCrudActions } from '@/common/view/useCrudActions';
import { iapService } from '@/services/iap';
import useVuelidate from '@vuelidate/core';
import { minValue, numeric, required, requiredIf } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useMixins() {
    const route = useRoute();

    const model = reactive({
        id: route.params?.id || null,
        name: null,
        feature: null,
        credit: null,
        price: null,
        priceId: null,
        packageId: null
    });

    const validations = {
        name: { required },
        packageId: { required },
        feature: { required },
        price: { required, numeric, minValue: minValue(0.01) },
        credit: { required, numeric, minValue: minValue(0) },
        priceId: { required: requiredIf(() => model.feature === 4) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = useCrudActions().executeAction({
        canExecute: () => model.id != null,
        request: () => iapService.get(model.id),
        onSuccess: ({ data }) => {
            model.id = data.id;
            model.name = data.name;
            model.packageId = data.packageId;
            model.priceId = data.priceId;
            model.price = data.price || 0;
            model.feature = data.feature || 0;
            model.credit = data.credit || 0;
        }
    });

    return { v$, model, fetch, features };
}

const features = [
    { value: 0, label: 'Shop' },
    { value: 1, label: 'Promotion' },
    { value: 2, label: 'Quest' },
    { value: 3, label: 'PiggyBank' },
    { value: 4, label: 'Subscription' },
    { value: 5, label: 'ScratchTicket' },
    { value: 6, label: 'ProgressLevel' },
    { value: 7, label: 'PromotionCycle' },
    { value: 8, label: 'PicwordMap' },
    { value: 9, label: 'StarterPack' }
];
